export default "__VITE_ASSET__6c97952b__"